import React, { useState } from "react";
import { FC } from "react";
import { ExclamationCircle, X } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useMarkPageNotificationsAsViewedMutation } from "../../../graphql/notification.hooks";

type Props = {
  link: string;
  id: number;
};

export const PublishToast: FC<Props> = ({ link, id }) => {
  const { t } = useTranslation();
  const [closeNotification] = useMarkPageNotificationsAsViewedMutation();
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const openPage = () => {
    if (link) window.location.href = link;
  };

  const copyLink = async () => {
    try {
      setIsCopied(true);

      await navigator.clipboard.writeText(link);

      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = async () => {
    try {
      await closeNotification({
        variables: {
          pageIds: [id],
        },
        refetchQueries: ["PageNotificationsForUser"],
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="publishToast col-12 p-3 border border-primary bg-blue-light d-flex align-items-center justify-content-between rounded-3">
      <div className="d-flex flex-wrap align-items-center col-11 gap-2 gap-md-3">
        <div className="w-auto d-flex align-items-center">
          <ExclamationCircle className="text-primary me-2 align-self-baseline mt-1" />
          <p className="pulishedLink text-primary m-0 text-break">
            {t("modal.Your page")}{" "}
            <a href={link} className="mx-1" style={{ wordBreak: "break-all" }}>
              {link.replace(/^https?:\/\//, "")}
            </a>{" "}
            {t("modal.is published!")}
          </p>
        </div>
        <div className="publishToastBtns col-12 col-md-auto d-flex align-items-center">
          <button
            onClick={openPage}
            className="btn btn-primary text-white fw-bold fs-7 me-3 p-0"
          >
            {t("modal.openPage")}
          </button>
          <button
            onClick={copyLink}
            disabled={isCopied}
            className="btn btn-outline-primary fw-normal text-primary white-hover fs-7 p-0"
          >
            {isCopied ? t("share.copied") : t("share.copyLink")}
          </button>
        </div>
      </div>
      <X
        onClick={handleClose}
        className="fs-3 text-gray cursor-pointer align-self-baseline align-self-lg-center"
      />
    </div>
  );
};
